module.exports = __webpack_public_path__ + "static/usecase_exchange2_right_en_bg@2x-67b0f7fea474d8c832f7a7c08c169760.png";